import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';

function handleEscapeKey(close) {
  return function (e) {
    if (e.code === 'Escape' || e.keyCode === 27) {
      close();
      e.preventDefault();
    }
  };
}

function onShowModal(modalHandler) {
  document.body.style.overflow = 'hidden';
  document.addEventListener('keydown', modalHandler);
}

function onHideModal(modalHandler) {
  document.body.style.overflow = '';
  document.removeEventListener('keydown', modalHandler);
}

function createFocusableElements(ref) {
  if (ref.current === null) {
    return new NodeList();
  }

  var focusableElements = ref.current.querySelectorAll("a[href]:not([disabled]), \n        button:not([disabled]), \n        textarea:not([disabled]), \n        input[type=\"text\"]:not([disabled]), \n        input[type=\"radio\"]:not([disabled]), \n        input[type=\"checkbox\"]:not([disabled]), \n        select:not([disabled])");
  return focusableElements;
}

export function FocusTrap(ref) {
  return function (e) {
    if (ref.current === null) {
      return;
    }

    var focusable = createFocusableElements(ref);
    var firstFocusable = focusable[0];
    var lastFocusable = focusable[focusable.length - 1];

    if (!(e.key === 'Tab')) {
      return;
    }

    if (e.shiftKey) {
      if (document.activeElement === firstFocusable) {
        lastFocusable.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusable) {
        firstFocusable.focus();
        e.preventDefault();
      }
    }
  };
}

function onSetFocus(focusTrapHandler) {
  document.addEventListener('keydown', focusTrapHandler);
}

function onRemoveFocus(focusTrapHandler) {
  document.removeEventListener('keydown', focusTrapHandler);
}

export var useModal = function useModal() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isShowing = _useState2[0],
      setIsShowing = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      mount = _useState4[0],
      setMount = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      triggerOrigin = _useState6[0],
      setTriggerOrigin = _useState6[1];

  var open = function open(triggerOrigin) {
    setMount(true);
    setIsShowing(true);
    setTriggerOrigin(triggerOrigin);
  };

  var close = function close() {
    options.onClose && options.onClose();
    setIsShowing(false);
  };

  useEffect(function () {
    if (mount && !isShowing && triggerOrigin) {
      var _triggerOrigin$curren;

      (_triggerOrigin$curren = triggerOrigin.current) === null || _triggerOrigin$curren === void 0 ? void 0 : _triggerOrigin$curren.focus();
    }
  }, [isShowing, mount]);
  var onHandleEscapeKey = handleEscapeKey(close);
  useEffect(function () {
    if (isShowing) {
      onShowModal(onHandleEscapeKey);
    } else {
      onHideModal(onHandleEscapeKey);
    }

    return function () {
      onHideModal(onHandleEscapeKey);
    };
  }, [isShowing]);
  var modalTuple = [isShowing, open, close];
  return modalTuple;
};
export function useFocus(isShowing, modalContainer) {
  var onFocusTrap = FocusTrap(modalContainer);
  useEffect(function () {
    if (isShowing) {
      var _modalContainer$curre;

      (_modalContainer$curre = modalContainer.current) === null || _modalContainer$curre === void 0 ? void 0 : _modalContainer$curre.focus();
      onSetFocus(onFocusTrap);
    } else {
      onRemoveFocus(onFocusTrap);
    }

    return function () {
      onSetFocus(onFocusTrap);
    };
  }, [isShowing]);
}
//# sourceMappingURL=Modal.hooks.js.map